<template>
  <li class="cx-list__item" v-if="poi && settings">
    <a class="cx-link"
      @click="openAccessibility"
    >
      <span class="cx-link__icon">
        <i class="fal fa-wheelchair"></i>
      </span>
      <span>{{ $t('accessibility.barrierFreeTravelGuide') || 'barrierFreeTravelGuide' }}</span>
    </a>
  </li>
</template>

<script>
import axios from 'axios';

export default {
  name: 'sight-map-accessibility-button',
  props: {
    id: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      poi: null,
      settings: null,
    };
  },
  mounted() {
    this.checkAccessibility();
  },
  methods: {
    getpoi(data) {
      return data.find(poi => poi.poiId && poi.poiId.match(new RegExp(`${this.id}$`)));
    },
    async checkAccessibility() {
      if (this.poi) return;

      let type = null;
      const match = this.$route.name.match(/^([a-z]*)-/);
      if (match) {
        type = match[1];
      } else if (!match && this.$route.name.match(/^DiningSearchAllRestaurant/)) {
        type = 'dining';
      } else {
        return;
      }


      const table = {
        'accommodation': ['hotels'],
        'dining': ['restaurants'],
        'sight': ['malls', 'sights', 'borders', 'expos'],
      };
      let check = table[type];
      if (!check) return;

      const param = { lang: null };
      const [settings, ...pois] = await Promise.all([
        axios(`/api/accessibility/${this.$i18n.locale}/accessibility.json`, param),
        ...check.map(poi => axios(`/api/accessibility/${this.$i18n.locale}/${poi}.json`, param)),
      ]);
      const mergedPOIs = pois.reduce((pois, poi) => poi.data ? [...pois, ...poi.data] : pois, []);
      if (mergedPOIs.length > 0 && settings.data) {
        this.poi = this.getpoi(mergedPOIs);
        this.settings = settings.data;
      }
    },
    async openAccessibility() {
      this.$emit('show', {
        poi: this.poi,
        settings: this.settings,
      });
    },
  },
};
</script>
